import { AbstractLogger } from "./AbstractLogger";

/**
 * Logs to the browser console.
 */
export class ConsoleLogger extends AbstractLogger {
    logError = (message: string, stackTrace?: string | undefined, errorTraceId?: string | undefined) =>
        console.error(message, errorTraceId, stackTrace);
}
